import {t} from './i18n.mjs';
import {EXTERNAL_REL} from './links.mjs';
import {legacyCopy} from './share.mjs';
// Legal documents inside the menu: the generated fragments of the standalone pages (German, otherwise English), fetched once per language.
export const docLanguage = lang => (lang === 'de' ? 'de' : 'en');
export function documentLoader({doc = document, fetchImpl = globalThis.fetch?.bind(globalThis)} = {}) {
  return async function load(el) {
    const lang = docLanguage(doc.documentElement.lang), name = el.dataset.doc;
    const body = el.querySelector('.menu-doc-body'), error = el.querySelector('.menu-doc-error'), note = el.querySelector('.menu-doc-note');
    note.hidden = ['de', 'en'].includes(doc.documentElement.lang);
    if (el.dataset.lang === lang) return true;
    error.hidden = true;
    try {
      const response = await fetchImpl(`/web/pages/fragments/${lang}-${name}.html`);
      if (!response.ok) throw Error(response.status);
      body.innerHTML = await response.text();
      // Every link except mailto leaves the map: open it in a new tab (also /impressum from the privacy policy).
      for (const a of body.querySelectorAll('a[href]:not([href^="mailto:"])')) { a.target = '_blank'; a.rel = EXTERNAL_REL; }
      el.dataset.lang = lang; return true;
    } catch { error.hidden = false; return false; }
  };
}
// Copy buttons ([data-copy]) inside the menu: the label switches to "Copied" for a moment.
export function installCopy(root, {nav = globalThis.navigator, doc = document, timers = globalThis} = {}) {
  root.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-copy]');
    if (!button) return;
    let ok = false;
    try { await nav.clipboard.writeText(button.dataset.copy); ok = true; } catch { ok = legacyCopy(button.dataset.copy, doc); }
    const label = button.querySelector('span');
    label.textContent = t(ok ? 'connectorCopied' : 'copyFailedShort'); button.classList.toggle('is-copied', ok);
    timers.setTimeout(() => { label.textContent = t('connectorCopy'); button.classList.remove('is-copied'); }, 1600);
  });
}
